/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseNotification } from './BaseNotification';
const NotificationCommentReplyNotificationAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('comment_notification')],
    ['fileId', codecNumber, 'file_id'],
]), BaseNotification);
export class NotificationCommentReplyNotificationAsJSON extends BaseNotification {
    static decode(input) {
        return NotificationCommentReplyNotificationAsJSONParser.decode(input).map(res => new NotificationCommentReplyNotificationAsJSON(res));
    }
    static unsafeDecode(input) {
        return NotificationCommentReplyNotificationAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NotificationCommentReplyNotificationAsJSONParser.encode(data);
    }
    static schema() {
        return NotificationCommentReplyNotificationAsJSONParser.schema();
    }
}
